/* eslint-disable import/no-unresolved */
import { useTranslation } from 'react-i18next';
import Landing from '../../../../assets/icons/flightBrief/landing.svg?react';
import Location from '../../../../assets/icons/flightBrief/location.svg?react';
import Takeoff from '../../../../assets/icons/flightBrief/takeoff.svg?react';
import { capitalizedValue, formatTimeString } from '../../../../domain/flightBrief/flightBriefUseCases';
import IconText from '../../../atoms/flightBriefPdf/IconText/IconText';
import typo from '../../../atoms/flightBriefPdf/flightBriefTypography.module.css';
import styles from './FlightBriefAirportInfo.module.css';

/**
 * Airport column for the flight brief PDF trip line. Maps a shared flight brief
 * destination to the Figma layout: city, IATA code, airport name and time.
 * @param {object} props
 * @param {Destination} [props.destination] - Departure or arrival from the shared flight brief.
 * @param {'departure' | 'arrival'} props.type - Which side of the trip line to render.
 * @param {string} props.locale - Active locale for date/time formatting.
 * @returns {JSX.Element}
 */
function FlightBriefAirportInfo({ destination, type, locale }) {
  const { t } = useTranslation(undefined, { lng: locale });
  const notAvailable = t('sharedFlightBrief.pdf.notAvailable');
  const airport = destination?.airport;
  const TimeIcon = type === 'departure' ? Takeoff : Landing;

  return (
    <div className={styles.airport}>
      <div className={styles.details}>
        <p className={styles.city}>
          {capitalizedValue(airport?.city) || notAvailable}
        </p>
        <p className={styles.code}>{airport?.airportCode?.toUpperCase() || notAvailable}</p>
        <IconText className={styles['icon-text']} icon={<Location aria-hidden />} textClassName={typo['p2-light']}>
          {airport?.name || notAvailable}
        </IconText>
      </div>
      {destination?.time ? (
        <div className={styles['time-slot']}>
          <div className={styles['time-row']}>
            <span className={styles['time-icon']}><TimeIcon aria-hidden /></span>
            <span className={styles['time-group']}>
              <span className={styles['time-value']}>
                {formatTimeString(destination.time, locale)}
              </span>
              {destination.utc ? (
                <span className={styles.utc}>
                  {`${t('sharedFlightBrief.flight.localTime')} (UTC${destination.utc})`}
                </span>
              ) : null}
            </span>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default FlightBriefAirportInfo;
